import { Result, Button } from 'antd';

export function SentryFallback({ resetError }: { resetError: () => void }) {
  return (
    <Result
      status="error"
      title="Что-то пошло не так"
      subTitle="Ошибка отправлена разработчикам. Можно попробовать перезагрузить страницу."
      extra={
        <Button type="primary" onClick={resetError}>
          Перезагрузить
        </Button>
      }
    />
  );
}
